import { useTranslation } from 'react-i18next';
import ErrorFallback from './../../assets/images/error.svg';
import './ErrorState.scss';

const STATIC_ERROR_DATA = {
    errorImage: ErrorFallback,
    errorTitle: {
        ua: "Помилка завантаження",
        en: "Upload error", 
        ru: "Ошибка загрузки",
        pl: "Błąd przesyłania",
        de: "Upload-Fehler",
        es: "Error de carga"
    },
    errorText: {
        ua: "Вибачте! Щось пішло не так",
        en: "Sorry! Something went wrong",
        ru: "Извините! Что-то пошло не так", 
        pl: "Przepraszamy! Coś poszło nie tak",
        de: "Entschuldigung! Etwas ist schiefgelaufen",
        es: "¡Lo siento! Algo salió mal"
    },
    button: {
        text: {
            ua: "Спробуйте ще раз",
            en: "Try again",
            ru: "Попробуйте еще раз",
            pl: "Spróbuj ponownie", 
            de: "Versuchen Sie es erneut",
            es: "Inténtalo de nuevo"
        }
    }
};

const ErrorState = ({ onRetry, theme = 'light' }) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const getSafeData = () => {
        const title = STATIC_ERROR_DATA.errorTitle[currentLang] || STATIC_ERROR_DATA.errorTitle.en;
        const text = STATIC_ERROR_DATA.errorText[currentLang] || STATIC_ERROR_DATA.errorText.en;
        const buttonText = STATIC_ERROR_DATA.button.text[currentLang] || STATIC_ERROR_DATA.button.text.en;
        const altText = title || 'Error';

        return { title, text, buttonText, altText };
    };

    const { title, text, buttonText, altText } = getSafeData();

    return (
        <div className={`error__fallback__wrapper theme-${theme}`} role="alert" aria-live="polite">
            <div className='error__fallback__card'>
                <div className='error__fallback__card__image'>
                    <img 
                        className='error__fallback__card__image__pic' 
                        src={STATIC_ERROR_DATA.errorImage} 
                        alt={altText}
                        loading="lazy"
                    />
                </div>
                <div className='error__fallback__card__content'>
                    <h4 className='error__fallback__card__content__title'>{title}</h4>
                    <p className='error__fallback__card__content__text'>{text}</p>
                    {onRetry && (
                        <button 
                            className='error__fallback__card__content__button'
                            onClick={onRetry}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            {buttonText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorState;